<!--
  /legal/agreement -- the Master Services Agreement, the ONE agreement
  (Jake, 2026-10-20; the separate "ThreadFlow Agreement" is gone).

  Compliance, the dashboard checklist and Review & Launch link here (the
  backend's AGREEMENT_URL default, api/src/agreement_terms.py). This page
  renders the WORKING DRAFT v0.1 (August 20, 2026) of the Distributor Platform
  Services Master Services Agreement, unedited, with a banner that says it is
  a draft (Jake, 2026-10-20: the link opens the working draft; this reverses
  the earlier decision to keep the draft out of the repo), and ends with the
  Owner's confirm (MsaConfirmPanel; temporary until e-sign lands).

  The text lives in agreementDraftHtml.js, generated from our own docx with
  pandoc (header of that file). It is a build-time constant, never user input,
  and a spec asserts it holds no script/img/iframe/handler or non-https links,
  which is what makes v-html safe here. When the final text is approved,
  regenerate that module and bump CURRENT_AGREEMENT_VERSION in the same change.
  PUBLIC route: anyone may read it; only a signed-in Owner can confirm.
-->
<template>
  <main class="legal-agreement" data-testid="legal-agreement-page">
    <p class="legal-agreement__back">
      <a href="/" data-testid="legal-agreement-back-to-app">&larr; Back to ThreadFlow</a>
    </p>
    <h1 class="legal-agreement__title">Master Services Agreement</h1>
    <p class="legal-agreement__banner" data-testid="legal-agreement-draft-banner" role="note">
      <strong>WORKING DRAFT v0.1 | August 20, 2026.</strong>
      This is a working draft, not final text. It is not for signature until
      reviewed and approved by ThreadFlow leadership and counsel.
    </p>
    <!-- eslint-disable-next-line vue/no-v-html -- build-time constant, see header -->
    <div class="legal-agreement__body" data-testid="legal-agreement-body" v-html="draftHtml" />
    <p class="legal-agreement__support">
      Questions about the agreement? Contact us at
      <a href="mailto:support@threadflow.com">support@threadflow.com</a>.
    </p>
    <MsaConfirmPanel />
    <p class="legal-agreement__back">
      <a href="/" data-testid="legal-agreement-back-to-app-bottom">&larr; Back to ThreadFlow</a>
    </p>
  </main>
</template>

<script>
import agreementDraftHtml from "./agreementDraftHtml";
import MsaConfirmPanel from "@/components/agreement/MsaConfirmPanel.vue";

export default {
  name: "AgreementPage",
  components: { MsaConfirmPanel },
  data() {
    return { draftHtml: agreementDraftHtml };
  },
};
</script>

<style scoped>
.legal-agreement {
  max-width: 820px;
  margin: 32px auto 64px;
  padding: 0 16px;
  line-height: 1.6;
  color: #1f2933;
}
.legal-agreement__back {
  margin: 0 0 16px;
}
.legal-agreement__banner {
  background: #fff4d6;
  border: 1px solid #e0b64a;
  border-radius: 4px;
  padding: 10px 14px;
}
.legal-agreement__body :deep(h1) {
  font-size: 1.4rem;
  margin: 2rem 0 0.75rem;
}
.legal-agreement__body :deep(h2) {
  font-size: 1.15rem;
  margin: 1.5rem 0 0.5rem;
}
.legal-agreement__body :deep(table) {
  display: block;
  overflow-x: auto;
  border-collapse: collapse;
  margin: 1rem 0;
  max-width: 100%;
}
.legal-agreement__body :deep(th),
.legal-agreement__body :deep(td) {
  border: 1px solid #c9ced6;
  padding: 6px 10px;
  text-align: left;
  vertical-align: top;
}
.legal-agreement__body :deep(th) {
  background: #f1f3f6;
}
.legal-agreement__body :deep(ul) {
  padding-left: 1.5rem;
}
@media print {
  .legal-agreement__back {
    display: none;
  }
  .legal-agreement {
    max-width: none;
    margin: 0;
    padding: 0;
  }
  .legal-agreement__body :deep(table) {
    display: table;
    page-break-inside: auto;
  }
  .legal-agreement__body :deep(tr) {
    page-break-inside: avoid;
  }
}
</style>
